import { getDialogHooks } from 'utilities/dialog-context/DialogContextHelpers';
import {
  BulkMemberTransferRequestDialog,
  BulkMemberTransferRequestDialogCallbackInput,
  BulkMemberTransferRequestUniqueProps,
} from '../BulkMemberTransferRequestDialog';

const { useDialogForContext, useDialog: useBulkMemberTransferRequestDialog } =
  getDialogHooks<
    BulkMemberTransferRequestUniqueProps,
    BulkMemberTransferRequestDialogCallbackInput
  >(BulkMemberTransferRequestDialog);

/** Registers the bulk transfer drawer in the shared dialog provider. */
export const useBulkMemberTransferRequestDialogForContext = useDialogForContext;

/**
 * Opens the bulk member transfer drawer from the members table.
 *
 * @returns Function accepting optional table prefill.
 */
export default useBulkMemberTransferRequestDialog;
